import clsx from "clsx";
import type { InputHTMLAttributes, ReactNode } from "react";
import { forwardRef } from "react";

import styles from "./index.module.css";

export interface IconInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: ReactNode;
  iconAlt?: string;
  containerClassName?: string;
  inputClassName?: string;
  iconClassName?: string;
  label?: string;
}

export const IconInput = forwardRef<HTMLInputElement, IconInputProps>(
  (
    { icon, containerClassName, inputClassName, iconClassName, style, label, value, ...inputProps },
    ref,
  ) => {
    return (
      <>
        {label && (
          <label htmlFor={inputProps.id} className={styles.label}>
            {label}
          </label>
        )}
        <div
          className={clsx(styles.inputGroup, containerClassName)}
          data-empty={!value}
          style={style}
        >
          <div className={clsx(styles.inputIcon, iconClassName)}>{icon && icon}</div>
          <input
            className={clsx(styles.input, inputClassName)}
            ref={ref}
            value={value}
            {...inputProps}
          />
        </div>
      </>
    );
  },
);
IconInput.displayName = "IconInput";
